import React, { Fragment } from "react";
import CustomInputField from "../../../../NewComponents/CustomHTMLElements/CustomInputField";
import CustomSelectDropdown from "../../../../NewComponents/CustomHTMLElements/CustomSelectDropdown";

export default function SignUpIndiv({
  countryCodes,
  allBanks,
  handleSubmitChange,
  genderData,
  submitState,
}) {
  return (
    <Fragment>
      <div className="col-md-6">
        <CustomInputField
          type="text"
          maxLength="30"
          label="Investor's First Name"
          placeholder="Enter First Name"
          name="first_name"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="text"
          maxLength="30"
          label="Investor's Last Name"
          placeholder="Enter Last Name"
          name="last_name"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-12">
        <CustomInputField
          type="email"
          maxLength="128"
          name="email"
          placeholder="Enter Email Address"
          label="Email address"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6 mb-1">
        <CustomSelectDropdown
          name="country_code"
          label="Country"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Country</option>
          {countryCodes &&
            countryCodes.map((country, index) => {
              const { country_code, name } = country;
              return (
                <option value={country_code} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      <div className="col-md-6 mb-1">
        <CustomSelectDropdown
          name="gender"
          label="Gender"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Gender</option>
          {genderData &&
            genderData.map((gender, index) => {
              const { name } = gender;
              return (
                <option value={name} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="number"
          maxLength="20"
          name="phone_number"
          placeholder="07011111111"
          label="Investor Phone Number"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomSelectDropdown
          name="bank_id"
          label="Bank"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Bank</option>
          {allBanks &&
            allBanks.map((bank, index) => {
              const { id, name } = bank;
              return (
                <option value={id} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="number"
          maxLength="20"
          name="bank_account_number"
          placeholder=""
          label="Account Number"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>

      <div className="col-md-6">
        <CustomInputField
          type="number"
          maxLength="20"
          name="identification_number"
          placeholder=""
          label={`Identification Number ${
            submitState?.country_code === "NG"
              ? "(BVN)"
              : submitState?.country_code === "KE"
              ? "(National ID)"
              : ""
          }`}
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
    </Fragment>
  );
}
